import styled from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';
import { PureImageUploader } from '@/components';
import { Button, Input, Link } from '@/ui';
import { DragDropIcon } from '@/icons';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media screen and ${DEVICES.LAPTOP_S} {
    background-color: transparent;
    padding: 0;
    gap: 1rem;
  }
`;

export const StyledFormBlockWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 0;
  }
`;

export const StyledFormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledFormSectionRow = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-direction: column;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
  }
`;

export const StyledText = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('14', '22')};
  white-space: pre-wrap;

  a {
    color: ${pickThemeColor('ORANGE_PRIMARY')};
    font-style: italic;
    margin-left: 0.25rem;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '26')};
  }
`;

export const StyledInput = styled(Input)`
  width: 100%;
  max-width: 30rem;
`;

export const StyledSecondaryTitle = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('20', '26', 'SEMI_BOLD')};
  }
`;

export const StyledDocumentsWrap = styled.div`
  display: grid;
  gap: 0.75rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StyledTitle = styled.h1`
  ${pickThemeFontStyles('26', '28', 'SEMI_BOLD')};
  text-align: center;
  margin: 0;
  color: ${pickThemeColor('DARK_PURPLE')};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
    text-align: left;
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    z-index: 40;
    width: 100%;

    @media screen and ${DEVICES.LAPTOP_S} {
      width: 19.5rem;
    }
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
    border-bottom: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    margin-bottom: 2rem;
    justify-content: center;
  }
`;

export const StyledLink = styled(Link)`
  margin-top: auto;

  span {
    ${pickThemeFontStyles('14', '20')};
  }
`;

export const StyledDragger = styled(PureImageUploader)`
  cursor: pointer;
  max-width: 45rem;

  &.ant-upload-wrapper {
    & .ant-upload-drag .ant-upload {
      padding: 0;
      border-radius: 0.5rem;

      @media screen and ${DEVICES.LAPTOP_S} {
        padding: 2rem 1.5rem;
        border: 1px dashed #cccccc;
      }
    }
    .ant-upload-drag-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }

    & .ant-upload.ant-upload-drag {
      background: ${pickThemeColor('BG_SECONDARY')};
      border: none;
    }
  }
`;

export const StyledUploadButton = styled(Button)`
  &&& {
    width: 100%;
    height: 3rem;
  }
`;

export const StyledDraggerPlaceholder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
  }
`;

export const StyledDraggerDescription = styled.div`
  display: flex;
  align-items: center;
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26')};
  gap: 1rem;

  svg {
    width: 3.5rem;
    height: 1.5rem;
  }
`;

export const StyledMessage = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'NORMAL')};
`;

export const StyledDragIcon = styled(DragDropIcon)`
  path {
    fill: ${pickThemeColor('GREY')};
  }
`;
